import { Component, input, output } from '@angular/core';
import { TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe } from '../../../../core/i18n';
import type { ReviewPackagingView } from '../../utils/map-review-packaging';
import { ReviewDetailCard } from '../review-detail-card/review-detail-card';

/**
 * Packaging summary card on Review & Pay (type, pieces, weight, handling).
 */
@Component({
  selector: 'app-review-packaging-summary',
  imports: [ReviewDetailCard, TranslatePipe, TypographyComponent],
  templateUrl: './review-packaging-summary.html',
  styleUrl: './review-packaging-summary.scss',
})
export class ReviewPackagingSummary {
  readonly view = input.required<ReviewPackagingView>();
  /** When false, hides Edit (Get Labels confirmation). */
  readonly showEdit = input(true);
  readonly editRequested = output<string>();
}
